<template>
  <div class="my-6 mx-4 mx-lg-10">
    <b-form @submit.prevent="onSubmit" class="text-left">
      <b-form-row class="justify-content-center">
        <b-col cols="12" md="6">
          <b-form-group
            class="form-group"              
            label-size="sm"
            label-color="#a6bbc3"
            label="Postcode"
          >
            <b-form-input
              v-model.lazy.trim="$v.postalCode.$model"
              placeholder="Postcode"
              :state="$v.postalCode.$dirty ? !$v.postalCode.$invalid : null"
            >           
            </b-form-input>
            <b-form-invalid-feedback>
              <div v-if="$v.postalCode.$invalid">
                {{ 'Geef a.u.b. een postcode' }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-form-row>
      <b-form-row class="justify-content-center">
        <b-col cols="12" md="6">
          <b-form-group 
            class="form-group"             
            label-size="sm"
            label-color="#a6bbc3"
            label="Inlogcode">
            <b-form-input
              v-model.lazy.trim="$v.loginKey.$model"
              placeholder="Uw persoonlijke inlogcode"
              :state="$v.loginKey.$dirty ? !$v.loginKey.$invalid : null"
            >           
            </b-form-input>
            <b-form-invalid-feedback>
              <div v-if="$v.loginKey.$invalid">
                {{ 'Geef a.u.b. een Achternaam' }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-row class="justify-content-center">
        <b-col cols="12" md="6">

          <span v-if="error">
            {{ error }}
          </span>
          <b-button 
            class="btn-block text-align justify-content-center"
            type="submit" 
            variant="primary" 
            :disabled="pending">
            <span
              class="spinner-border spinner-border-sm mr-2"
              role="status"
              aria-hidden="true"
              v-if="pending"
            ></span>
            <span>INLOGGEN</span>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
    <b-row class="justify-content-center mt-4">
      <b-col cols="12" md="6">
        <p class="font-size-sm disclaimer">Heeft u moeite met inloggen? Zorg dat u de persoonlijke inlogcode en uw postcode zoals vermeld
          op uw brief goed heeft overgenomen. Mocht u nog steeds niet kunnen inloggen, neem contact
          op met de hulplijn 020-3090901.</p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { validPostalCodeNetherlands } from '@/components/b2b/validationHelpers.js'

export default {
  name: 'B2bLoginForm',
  data() {
    return {
      postalCode: '',
      loginKey: '',
      pending: false,
      error: null
    }
  },
  validations() {
    return {
      loginKey: {
        required,
      },
      postalCode: {
        required,
        validPostalCodeNetherlands
      }
    }
  },
  methods: {
    async onSubmit() {
      this.error = null
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.pending = true
 
      const payload = {
        postalCode: this.postalCode,
        loginKey: this.loginKey
      }
      const result = await this.$store.dispatch('getIquoteId', payload)

      if (result.data) {
        this.$router.push(`/${this.$route.params.company}/${result.data.login.accessToken}/aanbod`)
      }
      else if (result.error.startsWith('Provide a valid zip')) {
        this.error = 'Geen geldige inloggegevens. Probeer het opnieuw.'
      }
      else {
        this.error = `Er is een fout opgetreden: ${result.error} Probeer het (later) opnieuw.`
      } 

      this.pending = false
    }
  },
  watch: {
    postalCode(val) {
      this.postalCode = val.toUpperCase().replace(/[^a-z0-9]/gi, '')
    },
  }
}
</script>